import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ContextParams } from '@igaming/types';
// import { LinkProvider } from '@igaming/core';
import React from 'react';
// import { useGlobalContext } from './context/useGlobalContext';
import { App } from './components';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export default function Root() {
  // const setContext = useGlobalContext((state) => state.setContext);
  // setContext(props);

  return (
    <QueryClientProvider client={queryClient}>
      {/* <LinkProvider
        basename={props.basename}
        rootDomain={props.queryParamsParent.referer}
      > */}
      <App />
      {/* </LinkProvider> */}
    </QueryClientProvider>
  );
}
